// src/components/MAP/components/FilterControls.js
import React from 'react';

const FilterControls = ({ visibleTypes, toggleIconType }) => {
  return (
    <div className="icon-toggles custom-two-column-selector">
      <div className="icon-columns-container">
        <div className="icon-column">
          <div className="icon-toggle-item">
            <div className="icon-label-container">
              <input
                type="checkbox"
                checked={visibleTypes.civil}
                onChange={() => toggleIconType("civil")}
              />
              <span className="type-label important">Civil (Moderate/Advisory)</span>
            </div>
          </div>
          <div className="icon-toggle-item">
            <div className="icon-label-container">
              <input
                type="checkbox"
                checked={visibleTypes.crime}
                onChange={() => toggleIconType("crime")}
              />
              <span className="type-label urgent">Crime (Emergency/Urgent)</span>
            </div>
          </div>
        </div>

        <div className="icon-column">
          <div className="icon-toggle-item">
            <div className="icon-label-container">
              <input
                type="checkbox"
                checked={visibleTypes.people}
                onChange={() => toggleIconType("people")}
              />
              <img src="/smallicons/people.png" alt="People" className="legend-icon" />
              <span>People</span>
            </div>
          </div>
          <div className="icon-toggle-item">
            <div className="icon-label-container">
              <input
                type="checkbox"
                checked={visibleTypes.car}
                onChange={() => toggleIconType("car")}
              />
              <img src="/smallicons/car.png" alt="Car" className="legend-icon" />
              <span>Vehicle</span>
            </div>
          </div>
          <div className="icon-toggle-item">
            <div className="icon-label-container">
              <input
                type="checkbox"
                checked={visibleTypes.object}
                onChange={() => toggleIconType("object")}
              />
              <img src="/smallicons/others.png" alt="Others" className="legend-icon" />
              <span>Others</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default FilterControls;